import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFLookupVendorCustomer } from "../../../../Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupContract } from "../../../../Shared/NewForms/NFLookupContract";
import { NFLookupEmployee } from "../../../../Shared/NewForms/NFLookupEmployee";
import { useFormContext } from "react-hook-form";

const IncomingCashsLoanRepaymentByEmployeeDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupEmployee title={t("Employee")} fieldName={"employeeId"} required />
        </Col>
        <Col sm={6}>
          <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} required />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupContract fieldName="contractId" title={t("Contract")} required />
        </Col>
      </Row>
    </>
  );
};

export default IncomingCashsLoanRepaymentByEmployeeDetail;
